import "./About.scss";
import React from "react";

// import Profile from "../../assets/Images/mainpic.png";

function About() {
  return (
    <section className="about" id="about">
      <div className="about-flex">
        <div className="contact-flex reveal">
          <h3 className="contact-nameheaderdesktop">About</h3>

          <p className="contact-copy">
            I'm Will, a front-end and e-commerce developer based in Toronto. I
            build responsive, user-friendly web experiences for retail and
            consumer brands, with hands-on experience across Salesforce Commerce
            Cloud, Shopify, Bloomreach, WordPress and custom JavaScript.
          </p>
          <p className="contact-copy">
            Before moving into development, I worked in marketing and account
            management, which gives me a practical understanding of campaigns,
            stakeholders, deadlines and conversion-focused design. I'm
            especially interested in the space between front-end development,
            e-commerce, experimentation and product experience.
          </p>
          <p className="contact-copy">
            Outside of work, I'm usually listening to music, travelling,
            cooking, or working on side projects.
          </p>
        </div>
      </div>
    </section>
  );
}

export default About;
